import React from 'react';

function LiveScore() {
  return (
    <div className="live-score">
      <h3>Live Score</h3>
      <p>Indosam CC: 150/3 (20 overs)</p>
      <p>Opponent: 120/5 (18 overs)</p>
      {/* Replace with real-time data via API */}
    </div>
  );
}

export default LiveScore;